import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { HelperService } from './helper.service';
import { Authen } from '../models/authen.model';

@Injectable({
  providedIn: 'root'
})
export class AuthenService {
    auth: Authen = new Authen();
    tokenJWT: string = null;
    refToken: string = null;
    isZPV: boolean = false;
    isSCFFM: boolean = false;

    constructor(private http: HttpService, private helper: HelperService)
    {
        console.log('auth service init');

        this.tokenJWT = localStorage.getItem('medi-jwt');
        this.refToken = localStorage.getItem('medi-reftoken');
    }

    login(user: string, pwd: string, type: string, callback: any) {
        let data = new FormData();
        data.append('user', user);
        data.append('pwd', pwd);
        data.append('type', type);

        console.log('login start');

        this.http.post('api/Authen/Login', data, res => {
            //console.log(res.Result);
            console.log('login success');

            this.auth.set(res.Result);
            this.setTokens(res.Result);

            this.isZPV = (this.auth.UserType == 'ZPV') ? true : false;
            this.isSCFFM = (this.auth.GroupUserCode == 'SC' || this.auth.GroupUserCode == 'FFM') ? true : false;

            if (callback != null) {
                callback(res);
            }
        }, error => {
                this.helper.alertFailed('User name or password is invalid', 'Login failed');
        });
    }

    logout() {
        console.log('auth logout');

        this.auth.reset();
        this.tokenJWT = null;
        this.refToken = null;

        localStorage.removeItem('medi-jwt');
        localStorage.removeItem('medi-reftoken');
    }

    reset() {
        console.log('reset');
        this.logout();
    }

    reLogin(callback: any) {
        console.log('relogin start');

        if (this.tokenJWT != null) {
            this.http.getSilent('api/Authen/Relogin', res => {
                console.log('relogin succ');
                //console.log(res.Result);

                this.auth.set(res.Result);
                this.isZPV = (this.auth.UserType == 'ZPV') ? true : false;
                this.isSCFFM = (this.auth.GroupUserCode == 'SC' || this.auth.GroupUserCode == 'FFM') ? true : false;    

                callback();

            }, err => {
                console.log('relogin: failed');
                this.reset();
            });
        }
        else
            this.reset();
    }

    setTokens(auth: any) {
        this.tokenJWT = auth.JWToken;
        this.refToken = auth.RefToken;

        localStorage.setItem('medi-jwt', this.tokenJWT);
        localStorage.setItem('medi-reftoken', this.refToken);
    }

    isLogined() {
        return (this.tokenJWT != null) ? true : false;
        //return true;
    }

    //get isZPV() {
    //    return this.auth.UserType == 'ZPV';
    //}

    get isPrincipal() {
        return this.auth.UserType == 'PRN';
    }

    get isPrnCodeAll() {
        return this.auth.PrnCode == 'All';
    }

    get LoginUser() {
        return this.auth.UserName;
    }

    get LoginType() {
        return this.auth.UserType;
    }

    get Principal() {
        return this.auth.PrnCode;
    }

    get PrincipalEx() {
        return (this.isZPV) ? 'All' : this.auth.PrnCode;
    }

    get UserInfo() {
        return this.auth;
    }

    getUser() {
        return this.auth.UserName;
    }
    get GroupUserCode() {
        return this.auth.GroupUserCode;
    }
    get UserNameInternal() {
        return this.auth.UserNameInternal;
    }
}
